import { atom } from 'recoil';

// All dashboards
export const allDashboards = atom({
  key: 'allDashboards',
  default: [],
});
